"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EtudeError_1 = require("../error/EtudeError");
const Exceptional_1 = require("../util/Exceptional");
const MathUtil_1 = require("../util/MathUtil");
class Degree {
    constructor() {
        ++Degree.size;
        Degree._values.push(this);
    }
    static values(startingDegree = Degree.TONIC) {
        let degrees = Degree._values.slice();
        MathUtil_1.default.rotate(degrees, startingDegree.getValue() - 1);
        return degrees;
    }
    ordinal() {
        return Degree._values.indexOf(this);
    }
    static valueOf(degreeString) {
        let degree = Degree[degreeString];
        if (degree instanceof Degree) {
            return degree;
        }
        throw EtudeError_1.default.forInvalid(Degree, degreeString);
    }
    static isValid(value) {
        return 1 <= value && value <= Degree.size;
    }
    static fromValue(value) {
        return Exceptional_1.default
            .of(value)
            .filter(Degree.isValid, EtudeError_1.default.forInvalid(Degree, value, "out of range"))
            .map(i => Degree.values()[i - 1]);
    }
    getValue() {
        return this.ordinal() + 1;
    }
    toString() {
        return Object.keys(Degree).find(d => Degree[d] === this);
    }
}
Degree.size = 0;
Degree._values = [];
Degree.TONIC = new Degree();
Degree.SUPERTONIC = new Degree();
Degree.MEDIANT = new Degree();
Degree.SUBDOMINANT = new Degree();
Degree.DOMINANT = new Degree();
Degree.SUBMEDIANT = new Degree();
Degree.LEADING_TONE = new Degree();
exports.default = Degree;
